// tslint:disable:no-any

import * as React from 'react';
import {
    DisplayMixture,
    DisplayMixTank,
    DisplayMixPressure
} from '../components/Display';

export interface IMixtureProps {
    // tslint:disable-next-line:no-any
    data: any;
}

export default class Mixture extends React.Component<IMixtureProps> {
    render() {
        return (
            <table className="standardTable">
                <thead>
                    <tr>
                        <th>Mixture</th>
                        <th>Tank Volume</th>
                        <th>Start Pressure</th>
                        <th>End Pressure</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.data.map((mix: any, index: number) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <DisplayMixture data={mix} />
                                </td>
                                <td>
                                    <DisplayMixTank data={mix.tankVolume} />
                                </td>
                                <td>
                                    <DisplayMixPressure
                                        data={mix.startPressure}
                                    />
                                </td>
                                <td>
                                    <DisplayMixPressure
                                        data={mix.endPressure}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveMixtures.tsx